export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["资产销毁"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["销毁金额"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退还账户"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["确认销毁"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["销毁金额"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["销毁金额不能大于发行金额"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["覆盖返还"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["待退还"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["资产销毁后将保留在储备中的金额"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["资产销毁后将退还到您账户的金额"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["资产销毁后将保留在储备中的金额。"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(E - B) × D × C = 抵押品覆盖"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["• E — 当前发行量\n• B — 销毁金额\n• D — 申报单价\n• C — 抵押品比率"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["抵押品退还"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["代币销毁后重新计算覆盖范围后将退还到您账户的抵押品金额。"])}
}